import FormSubmitVO from "./FormSubmitVO";
import {IAnyObject} from "../../../../../ts/common/SimpleInterface";
import {IMarkerProps} from "../../../../../module/osm/element/MapMarker";
import {getManager} from "../../../../../ts/manager/Manager";
import {LngLatBounds} from "maplibre-gl";

export default class MapLocationVO extends FormSubmitVO
{
    lat:number|null;
    lng:number|null
    boundsWidth:number|null = null;
    boundsHeight:number|null = null;
    hidden:boolean = false;

    address:string|null = null
    zoom:number|null = null
    placeID:number|null = null
    city:string|null = null
    state:string|null = null
    postcode:string|null = null
    country:string|null = null
    countryShort:string|null = null

    markerProps:IMarkerProps|null = null;

    constructor(lat:number|null = null, lng:number|null = null)
    {
        super();
        this.lat = lat;
        this.lng = lng;
    }

    isValid()
    {
        return (this.lat !== null) && (this.lng !== null);
    }

    hasBounds()
    {
        return this.isValid() && (this.boundsWidth !== null) && (this.boundsHeight !== null);
    }

    isEmpty(): boolean
    {
        return this.hidden || (this.lat === null) || (this.lng === null);
    }

    getSubmitValue(): IAnyObject|string
    {
        if(this.isEmpty()){
            return ""
        }
        const values:IAnyObject = {
            lat: this.lat,
            lng: this.lng,
        }
        if((this.boundsWidth !== null) && (this.boundsHeight !== null)){
            values.bounds_width = this.boundsWidth;
            values.bounds_height = this.boundsHeight;
        }
        return values;
    }

    getMarkerProps(draggable:boolean = false, bounds:LngLatBounds|null = null, allowHidden:boolean = false, reset:boolean = false):IMarkerProps|null
    {
        if(reset){
            this.markerProps = null;
        }

        if(!this.isValid()){
            this.markerProps = null;
            return this.markerProps;
        }
        if(!allowHidden && this.hidden){
            this.markerProps = null;
            return this.markerProps;
        }
        const latitude = this.lat ?? 0;
        const longitude = this.lng ?? 0;

        bounds = bounds ?? getManager().location.determineBounds(latitude, longitude, this.boundsWidth ?? 0.05, this.boundsHeight ?? 0.05)

        this.markerProps = {
            marker: {
                latitude: latitude,
                longitude: longitude,
                draggable: draggable
            },
            bounds: bounds,
            defaultZoomLevel: this.zoom ?? undefined
        }
        return this.markerProps;
    }

    clone(to?:MapLocationVO): MapLocationVO
    {
        to = to ?? new MapLocationVO();
        to.lat = this.lat;
        to.lng = this.lng;
        to.hidden = this.hidden;

        to.boundsWidth = this.boundsWidth;
        to.boundsHeight = this.boundsHeight;
        to.address = this.address;
        to.zoom = this.zoom;
        to.placeID = this.placeID;
        to.city = this.city;
        to.state = this.state;
        to.postcode = this.postcode;
        to.country = this.country;
        to.countryShort = this.countryShort;

        return to;
    }
}